import { render } from "./SaludFitDays.vue?vue&type=template&id=115c14fe&scoped=true"
import script from "./SaludFitDays.vue?vue&type=script&lang=js"
export * from "./SaludFitDays.vue?vue&type=script&lang=js"

import "./SaludFitDays.vue?vue&type=style&index=0&id=115c14fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115c14fe"]])

export default __exports__